import React from 'react'
import Logo from '../Images/Google-logo.png'
import Kaku from '../Images/Kaku.jpg'
import { Link } from 'react-router-dom'
import './ScheduleStyle.css'
import Navbar from '../HomeComponents/Navbar'

export default function MainSchedule() {
    return (
        <>
            <Navbar />


            <div className="main-section">
                <div className="sidebar">
                    <p className="sidebar-content">
                        Know Your Class Schedule
                    </p>
                </div>
                <div className="schedule-container">
                    <div className="schedule-text">
                        <div className="schedule-title">Choose Your Class</div>
                        <p className="schedule-subtitle">This will show you your timings</p>
                    </div>
                    <div className="class-container">


                        <div className="class-media-box">
                            <Link to="/day"> <div className="classes">
                                <h1 className="class-title">Seventh (VII)</h1>
                            </div></Link>
                            <Link to="/day"> <div className="classes">
                                <h1 className="class-title">Eighth (VIII)</h1>
                            </div></Link>
                        </div>

                        <div className="class-media-box">
                            <Link to="/day"> <div className="classes">
                                <h1 className="class-title">Seventh (VII)</h1>
                            </div></Link>
                            <Link to="/day"><div className="classes">
                                <h1 className="class-title">Eighth (VIII)</h1>
                            </div></Link>
                        </div>

                        <div className="class-media-box">
                            <Link to="/day"> <div className="classes">
                                <h1 className="class-title">Seventh (VII)</h1>
                            </div></Link>
                            <Link to="/day"><div className="classes">
                                <h1 className="class-title">Eighth (VIII)</h1>
                            </div></Link>
                        </div>



                        <div className="class-box">
                            <Link to="/day"> <div className="classes">
                                <h1 className="class-title">Seventh (VII)</h1>
                            </div></Link>
                            <Link to="/day"><div className="classes">
                                <h1 className="class-title">Eighth (VIII)</h1>
                            </div></Link>
                            <Link to="/day"><div className="classes">
                                <h1 className="class-title">Ninth (IX)</h1>
                            </div></Link>
                        </div>



                        <div className="class-box">
                            <Link to="/day"> <div className="classes">
                                <h1 className="class-title">Tenth (X)</h1>
                            </div></Link>
                            <Link to="/day">  <div className="classes">
                                <h1 className="class-title">Eleventh (XI)</h1>
                            </div></Link>
                            <Link to="/day">   <div className="classes">
                                <h1 className="class-title">Twelvth (XII)</h1>
                            </div></Link>
                        </div>



                    </div >
                </div >
            </div >
        </>

    )
}
